import { Component, inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  selector: 'app-debug',
  imports: [],
  templateUrl: './debug.html',
  styleUrl: './debug.scss'
})
export class Debug {

  oauth = inject(OAuthService);

  doSilentRefresh()
  {
    this.oauth.silentRefresh();
  }

}
